import * as React from 'react';

import styles from './FatImageBlock.css';
import { IFatInfrastructureListItem } from '../../types';
import { FatPanel } from '../FatPanel';

export function FatImageBlock({ title, description, iconUrl, imageUrl }: IFatInfrastructureListItem) {
  return (
    <li className={styles['container']}>
      <FatPanel
        title={title}
        description={description}
        iconUrl={iconUrl}
        containerStyles={styles['fat_panel']}
        type="big"
      />
      <div className={styles['image_container']}>
        <img src={imageUrl} alt={title} />
      </div>
    </li>
  );
}
